import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { AppShell, Group, Burger, Container, Box, Text, ScrollArea, Button, Flex } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

import MainNav from "./mainNav"
import Logo from "./logo"

// Δέχεσαι το pageContext απευθείας από τα props που στέλνει το Gatsby!
const Layout = ({ children, pageContext }) => {
  const [opened, { toggle, close }] = useDisclosure();

  // Έλεγχος: Αν το layoutType που βάλαμε στο gatsby-node είναι "blog", τότε είναι true!
  const isBlogPage = pageContext?.layoutType === "blog";

  const {
    wp: {
      generalSettings: { title, description },
    },
  } = useStaticQuery(graphql`
    query LayoutQuery {
      wp {
        generalSettings {
          title
          description
        }
      }
    }
  `)

  return (
    <AppShell
      header={{ height: 140, minHeight: 140 }} // Σταθερό ύψος για το header
      navbar={{
        width: 300,
        breakpoint: 'lg',
        collapsed: { desktop: true, mobile: !opened },
      }}>

      <Button
        component="a"
        href="#main-content"
        pos="absolute"
        top={-100} /* Κρυμμένο εκτός οθόνης */
        left={16}
        style={{ zIndex: 9999, transition: 'top 0.2s ease' }}
        onFocus={(e) => e.currentTarget.style.top = '16px'} /* Εμφανίζεται στο Tab */
        onBlur={(e) => e.currentTarget.style.top = '-100px'} /* Ξανακρύβεται */
        variant="filled"
        color="brandBlue"
        radius="md"
      >
        Skip to content
      </Button>

      {/* HEADER: Διώροφο Design (Συμμετρικό)! */}
      <AppShell.Header style={{ borderBottom: '1px solid var(--mantine-color-gray-2)', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Container size="lg" w="100%">

         {/* Πάνω Μέρος: Λογότυπο & Burger (για τα κινητά) */}
          <Flex 
            w="100%" 
            align="center" 
            justify={{ base: 'space-between', lg: 'center' }} 
            mb={{ base: 0, lg: 'md' }}
          >
            <Logo siteTitle={title} />
            <Burger opened={opened} onClick={toggle} hiddenFrom="lg" size="sm" aria-label="Toggle Navigation Menu" />
          </Flex>

          {/* Κάτω Μέρος: Το Μενού (Κεντραρισμένο, μόνο στο Desktop) */}
          <Group visibleFrom="lg" justify="center">
            <MainNav />
          </Group>

        </Container>
      </AppShell.Header>
      <AppShell.Navbar>
        <ScrollArea h="100%" type="auto" offsetScrollbars>
          <MainNav closeMenu={close} /> {/* <-- Του περνάμε τη συνάρτηση close! */}
        </ScrollArea>
      </AppShell.Navbar>

      {/* MAIN CONTENT */}
      <AppShell.Main id="main-content">
        {isBlogPage ? (
          /* Αν είναι σελίδα τύπου Blog (Αρχική, Κατηγορίες κλπ), 
             άφησέ το Full Width για να απλώνουν τα Grids και τα Heroes μας! */
          children
        ) : (
          /* Αν είναι οποιαδήποτε άλλη απλή σελίδα (π.χ. About, Contact, Single Post),
             τύλιξέ το αυτόματα στο κομψό, μαζεμένο Container της Mantine */
          <Container size="lg" py={{ base: 'xl', md: 50 }}>
            {children}
          </Container>
        )}
      </AppShell.Main>

      {/* FOOTER */}
      <Box component="footer" pt={60} pb={30} mt={80} style={{ backgroundColor: 'var(--mantine-color-gray-0)', borderTop: '1px solid var(--mantine-color-gray-2)' }}>
        <Container size="lg">

          <Text component="div" ta="center" size="sm" mb="md">
            <p>© {new Date().getFullYear()} {title} {description && ` - ${description}`}</p>
            <p>Built with <a href="https://www.gatsbyjs.com">Gatsby</a>: The Fastest Frontend for the Headless Web and <a href="https://wordpress.org/">WordPress</a>: The Open Source Platform that Powers the Web.</p>
            <p>Find the creator of this Gatsby theme @ <a href="https://elissavet.dev">Elissavet.dev</a>.</p>
          </Text>
        </Container>
      </Box>

    </AppShell>
  )
}

export default Layout